import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboTipoDosis`, method: 'GET', body: null, token: token})
}
